import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const TestimonialSection = ({ testimonials }) => {
  return (
    <section
      className="testimonial position-relative space"
      style={{
        backgroundImage: "url('/img/bg/testimonial-bg.png')",
        backgroundSize: "cover",
      }}
    >
   
      <div className="container">
        <div className="title-area text-center">
          <span className="sec-subtitle">Our Testimonials</span>
          <h2 className="sec-title">What Customers Say About Us</h2>
        </div>
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 4000 }}
          pagination={{ clickable: true }}
          loop={true}
          spaceBetween={30}
          breakpoints={{
            0: {
              slidesPerView: 1, // Mobile view: 1 slide
            },
            768: {
              slidesPerView: 2, // Tablet & desktop: 2 slides
            },
          }}
          className="testimonial-slider mt-5"
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-content text-center p-4 bg-white shadow rounded">

                <i className="fa-solid fa-quote-left mb-2"></i>
                <div className="rating mb-2">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className="fa-solid fa-star text-warning mx-1"
                    ></i>
                  ))}
                </div>
                <p className="revew mx-auto" style={{ maxWidth: 500 }}>
                  “{testimonial.text}”
                </p>
                <div className="author mt-3">
                  <h5 className="author-name mb-1">{testimonial.name}</h5>
                  <span className="author-degi">{testimonial.position}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialSection;
